// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMediaCamSettings_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 18.9998C9.10457 18.9998 10 18.1043 10 16.9998C10 15.8952 9.10457 14.9998 8 14.9998C6.89543 14.9998 6 15.8952 6 16.9998C6 18.1043 6.89543 18.9998 8 18.9998Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 22.9998H0V10.9998H16V22.9998ZM8 20.9998C10.2091 20.9998 12 19.2089 12 16.9998C12 14.7906 10.2091 12.9998 8 12.9998C5.79086 12.9998 4 14.7906 4 16.9998C4 19.2089 5.79086 20.9998 8 20.9998Z" class="svg-bg"/>
  <path d="M18 17.9297V15.4722C19.2275 14.3736 20 12.777 20 11C20 7.68628 17.3137 4.99999 14 4.99999C11.3876 4.99999 9.16522 6.6695 8.34148 8.99978H6.25209C6.46474 8.17367 6.80603 7.39921 7.25333 6.69902L6.22182 4.63601L7.63603 3.22179L9.69905 4.2533C10.4753 3.75741 11.3429 3.39181 12.2709 3.18735L13 1H15L15.7291 3.18735C16.6571 3.39181 17.5247 3.7574 18.3009 4.2533L20.364 3.22179L21.7782 4.63601L20.7467 6.69901C21.2426 7.47528 21.6082 8.34285 21.8126 9.27088L24 10V12L21.8126 12.7291C21.6082 13.6571 21.2426 14.5247 20.7467 15.301L21.7782 17.3639L20.364 18.7781L18.301 17.7467C18.2021 17.8098 18.1018 17.8709 18 17.9297Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMediaCamSettings is a generated icon component.
 */
let IconMediaCamSettings = IconMediaCamSettings_1 = class IconMediaCamSettings extends IconBaseElement {
    render() {
        return html `${IconMediaCamSettings_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMediaCamSettings.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMediaCamSettings = IconMediaCamSettings_1 = __decorate([
    customElement('zui-icon-media-cam-settings')
], IconMediaCamSettings);
export { IconMediaCamSettings };
